import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { WebshopService } from 'src/app/services/webshop/webshop.service';

@Component({
  selector: 'app-prefilled-modal',
  templateUrl: './prefilled-modal.component.html',
  styleUrls: ['./prefilled-modal.component.scss']
})
export class PrefilledModalComponent implements OnInit {
  @Input() modelId: any;
  @Input() brandId: any;
  @Input() loading: boolean;
  @Output() selectedOutlet = new EventEmitter<{ e: any }>();
  activeAllOutlets: any = []
  submitted: any = false
  selectedOutletId: any = ''

  constructor(
    private spinner: NgxSpinnerService,
    private webshopService: WebshopService,
  ) {

  }

  ngOnInit(): void {
    console.log(this.modelId, "modelId");
    this.selectedOutletId = ''
    this.outletForm.patchValue({ shopName: '' })
    this.getAllOutlets()
    this.spinner.show()
  }

  outletForm: FormGroup = new FormGroup({
    shopName: new FormControl('', [Validators.required]),
  });

  get setWebshop() {
    return this.outletForm.controls;
  }

  refreshModal() {
    this.selectedOutletId = ''
    this.submitted = false
    this.loading = false
    this.outletForm.patchValue({ shopName: '' })
    this.getAllOutlets()
  }
  getAllOutlets() {
    this.webshopService.getOutletsByBrand(this.brandId)
      .subscribe({
        next: (res) => {
          console.log(res, "outlets");
          let allData = res.data;

          this.activeAllOutlets = allData.filter(value => value.webshop_setup_status == 1 > -1);

        },
        error: (error) => { }
      })
  }

  confirmPrefill() {
    this.submitted = true
    this.loading = true

    if (this.selectedOutletId != '') {
      this.loading = false
      this.selectedOutlet.emit(this.selectedOutletId)
    } else {
      this.loading = false
    }
  }


  selectOutlet(e: any) {
    this.selectedOutletId = e.id
  }
}
